import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "maincat",
    path: `${APP_PREFIX_PATH}/main-category`,
    component: React.lazy(() => import("views/app-views/DropDown/Category")),
  },
  {
    key: "add-bussiness",
    path: `${APP_PREFIX_PATH}/bussiness/add-bussiness`,
    component: React.lazy(() => import("views/app-views/List/AddBusiness")),
  },
  {
    key: "subcat",
    path: `${APP_PREFIX_PATH}/sub-category`,
    component: React.lazy(() => import("views/app-views/DropDown/SubCategory")),
  },
  {
    key: "add-project",
    path: `${APP_PREFIX_PATH}/project/add-project`,
    component: React.lazy(() => import("views/app-views/List/AddProject")),
  },
  {
    key: "subcattype",
    path: `${APP_PREFIX_PATH}/sub-category-types`,
    component: React.lazy(() =>
      import("views/app-views/DropDown/Subcategorytypes")
    ),
  },
  {
    key: "Product",
    path: `${APP_PREFIX_PATH}/product/add-product`,
    component: React.lazy(() => import("views/app-views/List/AddProduct")),
  },
  {
    key: "Services",
    path: `${APP_PREFIX_PATH}/services/services`,
    component: React.lazy(() => import("views/app-views/List/Service")),
  },
  {
    key: "Services",
    path: `${APP_PREFIX_PATH}/service/add-service`,
    component: React.lazy(() => import("views/app-views/List/AddService")),
  },
  {
    key: "brand",
    path: `${APP_PREFIX_PATH}/brands`,
    component: React.lazy(() => import("views/app-views/List/UserList")),
  },
  {
    key: "add-user",
    path: `${APP_PREFIX_PATH}/user/add-user`,
    component: React.lazy(() => import("views/app-views/List/AddUser")),
  },
  {
    key: "banner",
    path: `${APP_PREFIX_PATH}/banners`,
    component: React.lazy(() => import("views/app-views/List/BannerList")),
  },
  {
    key: "add-banner",
    path: `${APP_PREFIX_PATH}/add-banner`,
    component: React.lazy(() => import("views/app-views/List/AddBanner")),
  },
  {
    key: "Category",
    path: `${APP_PREFIX_PATH}/Category/CategoryList`,
    component: React.lazy(() => import("views/app-views/DropDown/Category")),
  },
  {
    key: "mainCategory",
    path: `${APP_PREFIX_PATH}/Category/add-maincategory`,
    component: React.lazy(() => import("views/app-views/DropDown/AddCategory")),
  },
  {
    key: "SubCategory",
    path: `${APP_PREFIX_PATH}/SubCategory/SubCategory`,
    component: React.lazy(() => import("views/app-views/DropDown/SubCategory")),
  },
  {
    key: "SubCategoryadd",
    path: `${APP_PREFIX_PATH}/SubCategory/add-SubCategory`,
    component: React.lazy(() =>
      import("views/app-views/DropDown/AddSubCategory")
    ),
  },
  {
    key: "SubCategoryview",
    path: `${APP_PREFIX_PATH}/SubCategory/view-SubCategory`,
    component: React.lazy(() =>
      import("views/app-views/DropDown/ViewSubCategory")
    ),
  },
  {
    key: "SubCategoryedit",
    path: `${APP_PREFIX_PATH}/SubCategory/edit-SubCategory`,
    component: React.lazy(() =>
      import("views/app-views/DropDown/EditSubCategory")
    ),
  },
  {
    key: "Subcategorytypes",
    path: `${APP_PREFIX_PATH}/Subcategorytypes`,
    component: React.lazy(() =>
      import("views/app-views/DropDown/Subcategorytypes")
    ),
  },
  {
    key: "ViewSubCatTypes",
    path: `${APP_PREFIX_PATH}/ViewSubCatTypes`,
    component: React.lazy(() =>
      import("views/app-views/DropDown/ViewSubCatTypes")
    ),
  },
  {
    key: "add-types",
    path: `${APP_PREFIX_PATH}/add-types`,
    component: React.lazy(() => import("views/app-views/DropDown/AddTypes")),
  },
  {
    key: "user",
    path: `${APP_PREFIX_PATH}/static-images`,
    component: React.lazy(() => import("views/app-views/List/ImagesList")),
  },
  {
    key: "add-user",
    path: `${APP_PREFIX_PATH}/add-static-image`,
    component: React.lazy(() => import("views/app-views/List/AddStaticImage")),
  },
  {
    key: "bus-report",
    path: `${APP_PREFIX_PATH}/business-reports`,
    component: React.lazy(() => import("views/app-views/List/BusinessReports")),
  },
  {
    key: "bus-report-details",
    path: `${APP_PREFIX_PATH}/business-reports-details`,
    component: React.lazy(() =>
      import("views/app-views/List/BusinessReportDetails")
    ),
  },
  {
    key: "bus-delete",
    path: `${APP_PREFIX_PATH}/business-delete`,
    component: React.lazy(() => import("views/app-views/List/BusinessDelete")),
  },
  {
    key: "bus-delete-details",
    path: `${APP_PREFIX_PATH}/business-delete-details`,
    component: React.lazy(() =>
      import("views/app-views/List/BusinessDeleteDetails")
    ),
  },
  {
    key: "notification",
    path: `${APP_PREFIX_PATH}/notification`,
    component: React.lazy(() => import("views/app-views/List/Notifications")),
  },
  {
    key: "upload",
    path: `${APP_PREFIX_PATH}/upload`,
    component: React.lazy(() => import("views/app-views/DropDown/Upload")),
  },
];
